import { render, staticRenderFns } from "./display-field-code.vue?vue&type=template&id=ede089f4&scoped=true&"
import script from "./display-field-code.ts?vue&type=script&lang=ts&"
export * from "./display-field-code.ts?vue&type=script&lang=ts&"
import style0 from "./display-field-code.scss?vue&type=style&index=0&id=ede089f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ede089f4",
  null
  
)

export default component.exports